import React from 'react';
import ProductPatternPage from './ProductPatternPage';
import './ProductPatternPage.css';
import corianderImage from '../images/coriander-logo.png';
import corianderRenuka from "../images/coriander-renuka-img.jpeg"
const varieties = [
  {
    name: 'RENUKA',
    image: corianderRenuka,
    description: [
      'Quick-growing, high-yield single-cut or early multiple-harvest leafy variety',
      'Rapid germination, uniform aromatic green foliage, and high establishment speed',
      'First leaf harvest is ready in just 25-35 days',
    ],
  },
];

export default function CorianderPage() {
  return (
    <ProductPatternPage
      title="Coriander"
      varieties={varieties}
      pageClass="coriander-page"
      heroImage={corianderImage}
    />
  );
}
